import request from '../../axios';

const PatchActivateStore = async (payload: IActivateStoresProps) => {
  await request.patch(`api/v2/store/change-store-lab-active-status`, {
    ...payload,
  });
};

export default PatchActivateStore;
